import { render } from "./edit-delivery-challans.vue?vue&type=template&id=55022e7e"
import script from "./edit-delivery-challans.vue?vue&type=script&lang=js"
export * from "./edit-delivery-challans.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__